import { Pipe, PipeTransform } from "@angular/core";

const UNITS: [Intl.RelativeTimeFormatUnit, number][] = [
    ["year", 365 * 24 * 3600],
    ["month", 30 * 24 * 3600],
    ["week", 7 * 24 * 3600],
    ["day", 24 * 3600],
    ["hour", 3600],
    ["minute", 60],
];

const formatter = new Intl.RelativeTimeFormat("en", { numeric: "auto" });

/**
 * "5 minutes ago", "yesterday". Pure, so pass a `now` that changes (the
 * notifications service ticks one every minute) to keep it fresh.
 */
@Pipe({ name: "timeAgo", standalone: true })
export class TimeAgoPipe implements PipeTransform {
    transform(value: string | Date | null | undefined, now: number = Date.now()): string {
        if (!value) {
            return "";
        }
        const seconds = Math.round((new Date(value).getTime() - now) / 1000);
        if (Math.abs(seconds) < 60) {
            return "just now";
        }
        for (const [unit, size] of UNITS) {
            if (Math.abs(seconds) >= size) {
                return formatter.format(Math.trunc(seconds / size), unit);
            }
        }
        return "just now";
    }
}
